export const AUTHORISATION_TASK_STATUSES = [
  'notStarted',
  'inProgress',
  'readyToApprove',
  'completed',
  'cancelled',
  'rejected'
];

export const OPENED_AUTHORISATION_TASK_STATUSES = ['notStarted', 'inProgress', 'readyToApprove'];
export const CLOSED_AUTHORISATION_TASK_STATUSES = ['completed', 'cancelled', 'rejected'];

export enum AUTHORISATION_TASK_STATUSES_ENUM {
  NOT_STARTED = 'notStarted',
  IN_PROGRESS = 'inProgress',
  READY_TO_APPROVE = 'readyToApprove',
  COMPLETED = 'completed',
  CANCELED = 'cancelled',
  REJECTED = 'rejected'
}

export enum AUTHORISATION_TASK_REFERRER_ENUM {
  DE = 'diagramEditor'
}
